var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import KnockoutModel from "../../lib/knockout_model";
import "../../components/header";
import "../../components/leftMenu";
import "./edit.css";
import * as authorization from "../../lib/authorization";
import * as ajax from "../../app-lib/ajax_proxy";
import '../../components/tag-input';
import page from 'page';
var HeaderModel = /** @class */ (function (_super) {
    __extends(HeaderModel, _super);
    function HeaderModel(root) {
        var _this = _super.call(this, "/api/project/pc/edit", root, {}) || this;
        _this.tags = ko.observableArray();
        _this.pid = ko.observable(); //项目id
        _this.popur = ko.observable(0);
        _this.XiangXi = ko.observable(0);
        _this.postName = ko.observableArray([]);
        _this.choose_index = ko.observableArray();
        _this.userName = ko.observable();
        _this.chosebtn = ko.observable(0);
        _this.changename = ko.observable("");
        _this.ispool = ko.observable(false); //是否加入信息池
        _this.projecttext = ko.observable(); //项目说明
        _this.noticername = ko.observable(); //关注人姓名
        _this.cooperationMode = ko.observable(); //合作方式
        _this.projectName = ko.observable(); //项目名称
        _this.projectAddr = ko.observable(); //项目地点
        _this.projectArea = ko.observable(); //项目面积
        _this.projectParts = ko.observable(); //已入伙面积
        _this.provider = ko.observableArray(); //信息提供者
        _this.holder = ko.observableArray(); //持股人
        _this.projectManager = ko.observable(); //是否我方管理
        _this.username = ko.observableArray();
        _this.hiddendiv = ko.observable(false); //控制持股人div
        _this.hiddensub = ko.observable(true); //隐藏提交按钮
        _this.projectStuts = ko.observable(); //项目状态
        _this.protectOw = ko.observable();
        _this.lableList = ko.observable([{ lableColor: ko.observable(''), lableDescription: '', dataId: '', selected: ko.observable(false) }]); //标签数组
        return _this;
    }
    HeaderModel.prototype.Popur = function (m, e) {
        if (this.popur() == 1) {
            this.popur(0);
        }
        else {
            this.popur(1);
        }
    };
    HeaderModel.prototype.zkGengDuo = function (m, e) {
        var div = e.currentTarget.parentNode
            .nextElementSibling;
        if (!div.style.display || div.style.display == "block") {
            div.style.display = "none";
        }
        else {
            div.style.display = "block";
        }
    };
    HeaderModel.prototype.XiangXiZK = function (m, e) {
        var div = e.currentTarget.parentNode
            .parentNode.nextElementSibling;
        var div2 = div.nextElementSibling;
        if (!div.style.display || div.style.display == "none") {
            div.style.display = "block";
            div2.style.display = "block";
        }
        else {
            div.style.display = "none";
            div2.style.display = "none";
        }
    };
    HeaderModel.prototype.GengDuo = function (m, e) {
        var div = e.currentTarget
            .nextElementSibling;
        if (!div.style.display || div.style.display == "none") {
            div.style.display = "block";
        }
        else {
            div.style.display = "none";
        }
    };
    //是否纳入我的项目
    // ispools() {
    //   if( this.ispool()){
    //     this.ispool(false);
    //   }else{
    //     this.ispool(true);
    //   }
    // }
    //提交编辑数据
    HeaderModel.prototype.editsubmit = function () {
        var _this = this;
        var userIdages = [];
        for (var index in this.tags()) {
            userIdages[index] = this.tags()[index].username;
        }
        var isp = "";
        if (this.ispool()) {
            isp = null;
            userIdages = [];
        }
        else {
            isp = this.protectOw();
        }
        var pLabel = '';
        for (var i = 0; i < this.lableList().length; i++) {
            if (this.lableList()[i].selected()) {
                if (pLabel.length < 1) {
                    pLabel = this.lableList()[i].dataId;
                }
                else {
                    pLabel = pLabel + ',' + this.lableList()[i].dataId;
                }
            }
        }
        // this.data.userId = authorization.getUserId();
        ajax.put("/api/project/pc/edit", {
            userId: authorization.getUserId(),
            projectId: this.pid(),
            projectOwner: isp,
            noticer: userIdages,
            projectComment: this.projecttext(),
            projectLabel: pLabel //标签
        }).then(function (d) {
            if (d.status == 0) {
                if (d.message == '该项目正在审核，不能纳入信息池') {
                    return window.popBox.show(d.message);
                }
                else {
                    window.popBox.show(d.message).then(function () {
                        if (_this.ispool()) {
                            window.open('#/information/information', '_parent');
                        }
                        else {
                            window.open('#/project/Myproject', '_parent');
                        }
                    });
                }
            }
            else {
                window.popBox.show("编辑失败");
            }
        });
    };
    // 
    // ie设置
    HeaderModel.prototype.ieS = function () {
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
        var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
        var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
        // debugger;
        if (isIE) {
            var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
            reIE.test(userAgent);
            var fIEVersion = parseFloat(RegExp["$1"]);
            if (fIEVersion == 7) {
                var input1 = this.container.querySelector('#editInput1');
                var input2 = this.container.querySelector('#editInput2');
                input1.className = '11';
                input1.setAttribute('style', 'margin-top:10px;margin-left:5px;float:left;');
                input2.className = '11';
                input2.setAttribute('style', 'margin-top:10px;margin-left:5px;float:left;');
            }
            else if (fIEVersion == 8) {
                var input1 = this.container.querySelector('#editInput1');
                var input2 = this.container.querySelector('#editInput2');
                input1.className = '11';
                input1.setAttribute('style', 'margin-top:10px;margin-left:5px;float:left;');
                input2.className = '11';
                input2.setAttribute('style', 'margin-top:10px;margin-left:5px;float:left;');
            }
            else if (fIEVersion == 9) {
                var input1 = this.container.querySelector('#editInput1');
                var input2 = this.container.querySelector('#editInput2');
                input1.className = '11';
                input1.setAttribute('style', 'margin-top:10px;margin-left:5px;float:left;');
                input2.className = '11';
                input2.setAttribute('style', 'margin-top:10px;margin-left:5px;float:left;');
            }
            else if (fIEVersion == 10) {
                var input1 = this.container.querySelector('#editInput1');
                var input2 = this.container.querySelector('#editInput2');
                input1.className = '11';
                input1.setAttribute('style', 'margin-top:10px;margin-left:5px;float:left;');
                input2.className = '11';
                input2.setAttribute('style', 'margin-top:10px;margin-left:5px;float:left;');
            }
            else {
                var input1 = this.container.querySelector('#editInput1');
                var input2 = this.container.querySelector('#editInput2');
                input1.className = '11';
                input1.setAttribute('style', 'margin-top:10px;margin-left:5px;float:left;');
                input2.className = '11';
                input2.setAttribute('style', 'margin-top:10px;margin-left:5px;float:left;');
            }
        }
        else if (isEdge) {
            var input1 = this.container.querySelector('#editInput1');
            var input2 = this.container.querySelector('#editInput2');
            input1.className = '11';
            input1.setAttribute('style', 'margin-top:10px;margin-left:5px;float:left;');
            input2.className = '11';
            input2.setAttribute('style', 'margin-top:10px;margin-left:5px;float:left;');
        }
        else if (isIE11) {
            var input1 = this.container.querySelector('#editInput1');
            var input2 = this.container.querySelector('#editInput2');
            input1.className = '11';
            input1.setAttribute('style', 'margin-top:10px;margin-left:5px;float:left;');
            input2.className = '11';
            input2.setAttribute('style', 'margin-top:10px;margin-left:5px;float:left;');
        }
        else {
            // return -1;//不是ie浏览器           
        }
        // }
    };
    // 项目信息补全
    HeaderModel.prototype.goProInfo = function () {
        page('/project/projectInfo?pId=' + this.pid());
    };
    // 获取标签列表
    HeaderModel.prototype.getLableList = function () {
        var _this = this;
        console.log(this.viewModel());
        ajax.get('/api/label').then(function (d) {
            _this.lableList([]);
            for (var n = 0; n < d.data.length; n++) {
                _this.lableList().push({ lableColor: ko.observable(''), lableDescription: '', dataId: '', selected: ko.observable(false) });
            }
            _this.lableList(_this.lableList());
            for (var i = 0; i < _this.lableList().length; i++) {
                _this.lableList()[i].lableDescription = d.data[i].name;
                _this.lableList()[i].lableColor(d.data[i].colour);
                _this.lableList()[i].dataId = d.data[i].id;
                // this.lableList()[i].selected = d.data[i].id;
            }
        });
    };
    // 选择标签
    HeaderModel.prototype.selectLabel = function (d, r) {
        console.log(d, r);
        var m = 0;
        for (var i = 0; i < this.lableList().length; i++) {
            if (this.lableList()[i].selected()) {
                m++;
            }
        }
        if (this.lableList()[d].selected()) {
            this.lableList()[d].selected(false);
        }
        else {
            if (m < 5) {
                this.lableList()[d].selected(true);
            }
            else {
                return window.popBox.show('最多选择五个标签');
            }
        }
    };
    HeaderModel.prototype.loadbubble = function () {
        var arr = [];
        for (var i = 0; i < 7; i++) {
            arr.push(localStorage.getItem(i.toString()));
        }
        return ajax.post('/api/statistics/smessage', { userId: authorization.getUserId(), time: arr }).then(function (d) {
            ko.postbox.publish('leftMenu_myProject', d.data.count0);
            ko.postbox.publish('leftMenu_myFollowProject', d.data.count1);
            ko.postbox.publish('leftMenu_noFollowNews', d.data.count2);
            ko.postbox.publish('leftMenu_waitProjectNews', d.data.count3);
            ko.postbox.publish('leftMenu_signgedProjectNews', d.data.count4);
            ko.postbox.publish('leftMenu_abandonProjectNews', d.data.count5);
            ko.postbox.publish('leftMenu_auditMessage', d.data.count6);
        });
    };
    HeaderModel.prototype.loadnum = function () {
        this.getLableList();
        return ajax.get('/api/statistics/message', { userid: authorization.getUserId(), loginTime: new Date()["Format"]('yyyy-MM-dd hh:mm:ss') }).then(function (d) {
            ko.postbox.publish('leftMenu_allProject', d.data.allProject);
            ko.postbox.publish('leftMenu_followProject', d.data.followProject);
            ko.postbox.publish('leftMenu_nofollow', d.data.nofollow);
            ko.postbox.publish('leftMenu_waitProject', d.data.waitProject);
            ko.postbox.publish('leftMenu_signgedProject', d.data.signgedProject);
            ko.postbox.publish('leftMenu_abandonProject', d.data.abandonProject);
            ko.postbox.publish('leftMenu_noReadProject', d.data.noReadProject);
        });
    };
    HeaderModel.prototype.load = function () {
        this.ispool(false);
        return Promise.all([this.loadnum(), this.loadData()]).then(function () { });
    };
    HeaderModel.prototype.onViewModelSetting = function (d) {
        this.cooperationMode(d.data.editData[0].cooperationMode);
        if (this.cooperationMode() == "股权合作") {
            this.hiddendiv(true);
        }
        else if (this.cooperationMode() != "股权合作") {
            this.hiddendiv(false);
        }
        this.projectName(d.data.editData[0].projectName);
        this.projectAddr(d.data.editData[0].projectAddr);
        this.projectArea(d.data.editData[0].projectArea);
        this.projectParts(d.data.editData[0].projectParts);
        this.projecttext(d.data.editData[0].projectComment);
        this.tags(d.data.editData[0].noticer);
        this.protectOw(d.data.editData[0].projectOwner);
        this.postName(d.data.editData[0].noticer);
        this.projectStuts(d.data.projectStatus); //项目状态
        if (this.projectStuts() == '完成' || this.projectStuts() == '放弃') {
            this.hiddensub(false);
        }
        else {
            this.hiddensub(true);
        }
        this.provider(d.data.editData[0].provider); //信息提供者
        this.holder(d.data.editData[0].holder); //持股人
        this.projectManager(parseInt(d.data.editData[0].projectManager)); //是否我方里
        if (d.data.editData[0].label != null) {
            for (var i = 0; i < d.data.editData[0].label.length; i++) {
                for (var m = 0; m < this.lableList().length; m++) {
                    if (d.data.editData[0].label[i].id == this.lableList()[m].dataId) {
                        this.lableList()[m].selected(true);
                    }
                }
            }
        }
        return Promise.resolve(false);
    };
    return HeaderModel;
}(KnockoutModel));
var mModel = /** @class */ (function (_super) {
    __extends(mModel, _super);
    function mModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    mModel.prototype.init = function () {
        this.hm = new HeaderModel(this.container.querySelector(".Myproject"));
        // this.hm.bind();
    };
    mModel.prototype.update = function (arg) {
        this.hm.ieS();
        this.hm.pid(arg.routeData.query["id"]);
        this.hm.data.projectId = arg.routeData.query["id"];
        return this.hm.load();
    };
    return mModel;
}(Page));
export default mModel;
